var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTqaLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: "4.71in",
    height: "3.55in",
    viewBox: "0 0 339.43 255.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#fb4e00;stroke-width:0px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M109.46,148.8h-27.8v-45.86h27.09v-12.9h-27.09v-18.63h-12.9v78.1l12.18,12.18h28.52v-12.9ZM188.99,90.04h-56.61l-12.18,12.18v47.29l12.18,12.18h43.42v21.5h13.18v-93.15ZM133.1,102.94h42.71v45.86h-42.71v-45.86ZM270.68,90.04h-56.61l-12.18,12.18v47.29l12.18,12.18h35.11v-12.9h-34.39v-45.86h42.99v58.76h12.9v-71.65Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTqaLogo);
export default __webpack_public_path__ + "static/media/tqa-logo.0b04bfa65f6ad23e0cb9fc1d9ee99aa5.svg";
export { ForwardRef as ReactComponent };